module.exports = __webpack_public_path__ + "09c1a8f373e1aeb22a6ee7a195a1346a.svg";